module.exports = __webpack_public_path__ + "static/media/dery.08312e47.png";